// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

// Authentication layout components
import AuthLayout from "views/layouts/AuthLayout";

import { Link, useNavigate } from "react-router-dom";

// Image
import lock from "assets/images/illustrations/lock.png";
import { useState } from "react";
import ValidationService from "services/ValidationService";
import Apiservice from "services/ApiService";
import Helpers from "utils/Helpers";
import { toast } from "react-toastify";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [sendDisabled, setSendDisabled] = useState(false);
  const navigate = useNavigate();

  const handleSetEmail = (e) => {
    setEmail(e.target.value);
    setEmailError(false);
  };

  const handleSendEmail = async () => {
    if (!ValidationService.isValidEmail(email)) {
      setEmailError(true);
      return;
    }

    const response = await Apiservice.postData(
      "/auth/send-reset-password",
      { email: email },
      null,
      []
    );
    if (!response) return;
    setSendDisabled(true);
    toast.success(
      "Στάλθηκε σύνδεσμος επαναφορας κωδικού μέσω email. Θα μεταφερθείτε στην κεντρική σελίδα.",
      {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: false,
        theme: "colored",
      }
    );
    // Wait 10 seconds
    await Helpers.waitTimeout(1000 * 10);
    navigate("/login");
  };
  return (
    <AuthLayout
      title="Επαναφορά Κωδικού"
      description="Συμπληρώστε το email σας. Αν αντιστοιχεί σε χρήστη θα σας αποσταλλεί σύνδεσμος για επαναφορά κωδικού."
      illustration={{
        image: lock,
        title: "Επαναφορά Κωδικού Πρόσβασης",
      }}
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftInput
            type="email"
            placeholder="Email"
            size="large"
            onChange={handleSetEmail}
            error={emailError}
          />
        </SoftBox>

        <SoftBox mt={4} mb={1}>
          <SoftButton
            variant="gradient"
            color="info"
            size="large"
            fullWidth
            onClick={handleSendEmail}
            disabled={sendDisabled}
          >
            ΑΠΟΣΤΟΛΗ ΣΥΝΔΕΣΜΟΥ
          </SoftButton>
        </SoftBox>
        <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Θυμηθήκατε τον κωδικό σας? Επιστροφή στην{" "}
            <SoftTypography
              component={Link}
              to="/login"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Σύνδεση.
            </SoftTypography>
          </SoftTypography>
        </SoftBox>
      </SoftBox>
    </AuthLayout>
  );
}

export default ForgotPassword;
